import { render, staticRenderFns } from "./ShopStoreOrgInfo.vue?vue&type=template&id=43136848&scoped=true"
import script from "./ShopStoreOrgInfo.vue?vue&type=script&lang=js"
export * from "./ShopStoreOrgInfo.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreOrgInfo.vue?vue&type=style&index=0&id=43136848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43136848",
  null
  
)

export default component.exports